import React, {
    useState,
    useEffect,
    useContext,
    useRef
}
from "react";

import {store}
from "../../../context/store";

import {functions}
from "../../../constants/common-functions";

import {
    COLOR_UTILISATION_OCCUPIED,
    COLOR_UTILISATION_SIGNS_OF_LIFE,
    COLOR_UTILISATION_VACANT,
    OMNISCAN_CORPORATE_TURQUOIS
}
from "../../../constants/colors";

import {
    FALSE
}
from "../../../constants/general-constants";

import {
    EMPTY_FILTER_BEAN
}
from "../../../constants/filter-constants";

import {
    useParams
}
from "react-router-dom";

import Header
from "../../../components/Header";

import AmChartRingIndicator
from "../../../components/AmChartRingIndicator";

import AmChartSimpleBar
from "../../../components/AmChartSimpleBar";

import AmChartDateLine
from "../../../components/AmChartDateLine";

import UtilisationKpiBox
from "../components/UtilisationKpiBox";

import UtilisationKpiBoxDate
from "../components/UtilisationKpiBoxDate";

import UtilisationChartProfileUnused
from "../components/UtilisationChartProfileUnused";

import UtilisationChartEfficiency
from "../components/UtilisationChartEfficiency";

import "./MobileUtilisationAll.css";


import MobileHeader
from "../../home/mobile/components/MobileHeader";

import MobileDashboardPhotoNavigator
from "./components/MobileDashboardPhotoNavigator";


export default function MobileUtilisationAll()
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // Parameters
    //--------------------------------------------------------

    const facilityIdParam =
        useParams()["facilityId"];

    const spaceTypeIdParam =
        useParams()["spaceTypeId"];


    //--------------------------------------------------------
    // KPI State
    //--------------------------------------------------------

    const [utilisationAvg, setUtilisationAvg] =
        useState(0);

    const [utilisationMax, setUtilisationMax] =
        useState(0);

    const [seats, setSeats] =
        useState(0);

    const [observations, setObservations] =
        useState(0);

    const [datePeak, setDatePeak] =
        useState("");

    const [dateMin, setDateMin] =
        useState("");

    const [timePeak, setTimePeak] =
        useState("");

    const [timeMin, setTimeMin] =
        useState("");


    //--------------------------------------------------------
    // Chart State
    //--------------------------------------------------------

    const [leftBarChartData, setLeftBarChartData] =
        useState([]);

    const [leftBarChartHeight, setLeftBarChartHeight] =
        useState("220px");

    const [dataTimeline, setDataTimeline] =
        useState([]);


    //--------------------------------------------------------
    // Navigation / Filter State
    //--------------------------------------------------------

    const [filterBean, setFilterBean] =
        useState(EMPTY_FILTER_BEAN);

    const [facilityId, setFacilityId] =
        useState("-100");

    const [floorId, setFloorId] =
        useState("-100");

    const [floorZoneId, setFloorZoneId] =
        useState("-100");

    const [spaceId, setSpaceId] =
        useState("-100");

    const [spaceTypeId, setSpaceTypeId] =
        useState("-100");

    const [parentSpaceTypeId, setParentSpaceTypeId] =
        useState("-100");

    const [organisationId, setOrganisationId] =
        useState("-100");

    const [parentOrganisationId, setParentOrganisationId] =
        useState("-100");

    const [showCoreDayOnly, setShowCoreDayOnly] =
        useState(0);

    const [showDesksMeetings, setShowDesksMeetings] =
        useState("-100");


    //--------------------------------------------------------
    // Other State
    //--------------------------------------------------------

    const [loaded, setLoaded] =
        useState(false);
		
	const [showMenu, setShowMenu] =
				useState(false);
								
	const [showFilters, setShowFilters] =
	    useState(false);

    const refFacility =
        useRef(null);


    //--------------------------------------------------------
    // Initialisation
    //--------------------------------------------------------

    useEffect(
        () =>
        {

            if(loaded)
            {
                return;
            }

            resetSearch();

            setLoaded(true);

        },
        []
    );


    //--------------------------------------------------------
    // Space Type
    //--------------------------------------------------------

    useEffect(
        () =>
        {

            setParentSpaceTypeId(
                spaceTypeIdParam
            );

            setFilterBean(
                {
                    ...EMPTY_FILTER_BEAN,

                    spaceTypes:
                        spaceTypeIdParam !== "-100"
                            ?
                            [
                                parseInt(
                                    spaceTypeIdParam
                                )
                            ]
                            :
                            []
                }
            );

        },
        [
            spaceTypeIdParam
        ]
    );


    //--------------------------------------------------------
    // Load Dashboard
    //--------------------------------------------------------

    useEffect(
        () =>
        {

            if(
                parentSpaceTypeId === "-100"
            )
            {
                return;
            }


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetaverage",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                populateUtilisationAvg
            );


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetmax",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                populateUtilisationMax
            );


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetcapacity",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                populateSeats
            );


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetobservations",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                populateObservations
            );


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetdatemax",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                calculateDatePeak
            );


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetdatemin",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                calculateDateMin
            );


            //------------------------------------------------
            // Breakdown Chart
            //------------------------------------------------

            if(
                facilityId === "-100"
            )
            {

                functions.postFilterBeanAjax(
                    "/resolutionsoftwareplatform/utilisationstandardgetavgbyfacility",
                    functions.buildPostBodyFilterBeanQueryContext(
                        filterBean,
                        queryContext
                    ),
                    populateDataByFacility
                );

            }
            else if(
                floorId === "-100"
            )
            {

                functions.postFilterBeanAjax(
                    "/resolutionsoftwareplatform/utilisationstandardgetavgbyfloor",
                    functions.buildPostBodyFilterBeanQueryContext(
                        filterBean,
                        queryContext
                    ),
                    populateDataByFloor
                );

            }
            else if(
                spaceId === "-100"
            )
            {

                functions.postFilterBeanAjax(
                    "/resolutionsoftwareplatform/utilisationstandardgetavgbyspace",
                    functions.buildPostBodyFilterBeanQueryContext(
                        filterBean,
                        queryContext
                    ),
                    populateDataBySpace
                );

            }


            loadDataTimeline();

        },
        [
            parentSpaceTypeId,
            filterBean,
            queryContext?.utilisationSurveyId
        ]
    );


    //--------------------------------------------------------
    // Chart Height
    //--------------------------------------------------------

    useEffect(
        () =>
        {

            const calculatedHeight =
                (
                    28 *
                    leftBarChartData.length
                )
                +
                80;

            setLeftBarChartHeight(
                Math.max(
                    calculatedHeight,
                    220
                )
                +
                "px"
            );

        },
        [
            leftBarChartData
        ]
    );


    //--------------------------------------------------------
    // Reset
    //--------------------------------------------------------

    const resetSearch =
        () =>
        {

            setFacilityId(
                facilityIdParam ||
                "-100"
            );

            setFloorId("-100");

            setFloorZoneId("-100");

            setSpaceId("-100");

            setSpaceTypeId("-100");

            setOrganisationId("-100");

            setParentOrganisationId("-100");

            setShowCoreDayOnly(0);

        };


    //--------------------------------------------------------
    // Timeline
    //--------------------------------------------------------

    const loadDataTimeline =
        () =>
        {

            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationgetbydatewithoutfilterandsignsoflife",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                handleDataTimeline
            );

        };


    const handleDataTimeline =
        (results) =>
        {

            const tempData =
                results.map(
                    ({
                        label,
                        vacant,
                        occupied,
                        signsOfLife
                    }) =>
                    ({
                        id:
                            label,

                        date:
                            functions
                                .convertUtilisationLabelToDate(
                                    label
                                ),

                        vacant:
                            parseInt(
                                vacant
                            ),

                        occupied:
                            parseInt(
                                occupied
                            ),

                        signsOfLife:
                            parseInt(
                                signsOfLife
                            )
                    })
                );

            setDataTimeline(
                tempData
            );

        };


    //--------------------------------------------------------
    // KPI Handlers
    //--------------------------------------------------------

    const populateSeats =
        (obj) =>
        {

            setSeats(
                obj.returnDouble
            );

        };


    const populateObservations =
        (obj) =>
        {

            setObservations(
                obj.returnDouble
            );

        };


    const populateUtilisationAvg =
        (obj) =>
        {

            setUtilisationAvg(
                obj.returnDouble
            );

        };


    const populateUtilisationMax =
        (obj) =>
        {

            const value =
                obj.returnDouble;

            setUtilisationMax(
                parseInt(value) > 100
                    ?
                    100
                    :
                    value
            );

        };


    const calculateDatePeak =
        (input) =>
        {

            setTimePeak(
                input.hour
            );

            setDatePeak(
                input.returnDate
            );

        };


    const calculateDateMin =
        (input) =>
        {

            setTimeMin(
                input.hour
            );

            setDateMin(
                input.returnDate
            );

        };


    //--------------------------------------------------------
    // Breakdown Data
    //--------------------------------------------------------

    const populateDataByFacility =
        (results) =>
        {

            const data =
                results.map(
                    (item) =>
                    ({
                        id:
                            item.id,

                        label:
                            item.name,

                        value:
                            item.avg
                    })
                );

            setLeftBarChartData(
                data
            );

        };


    const populateDataByFloor =
        (results) =>
        {

            const data =
                results.map(
                    (item) =>
                    ({
                        id:
                            item.id,

                        label:
                            item.name,

                        value:
                            item.avg
                    })
                );

            setLeftBarChartData(
                data
            );

        };


    const populateDataBySpace =
        (results) =>
        {

            const data =
                results.map(
                    (item) =>
                    ({
                        id:
                            item.id,

                        label:
                            item.code,

                        value:
                            item.avg
                    })
                );

            setLeftBarChartData(
                data
            );

        };


    //--------------------------------------------------------
    // Breakdown Navigation
    //--------------------------------------------------------

    const clickFacility =
        (id) =>
        {

            setFacilityId(
                id
            );

        };


    const clickFloor =
        (id) =>
        {

            setFloorId(
                id
            );

        };


    const clickSpace =
        (id) =>
        {

            setSpaceId(
                id
            );

        };


    const handleBarClick =
        (id) =>
        {

            if(
                facilityId === "-100"
            )
            {

                clickFacility(
                    id
                );

            }
            else if(
                floorId === "-100"
            )
            {

                clickFloor(
                    id
                );

            }
            else
            {

                clickSpace(
                    id
                );

            }

        };


    //--------------------------------------------------------
    // Timeline Graphs
    //--------------------------------------------------------

    const dataByDateGraphsStacked =
        [
            {
                id:
                    "occupied",

                title:
                    "Occupied",

                keyColumn:
                    "occupied",

                color:
                    COLOR_UTILISATION_OCCUPIED
            },

            {
                id:
                    "signsOfLife",

                title:
                    "Signs Of Life",

                keyColumn:
                    "signsOfLife",

                color:
                    COLOR_UTILISATION_SIGNS_OF_LIFE
            },

            {
                id:
                    "vacant",

                title:
                    "Available",

                keyColumn:
                    "vacant",

                color:
                    COLOR_UTILISATION_VACANT
            }
        ];
		
		


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (
		<div
		    style={{
		        display:"flex",
		        flexDirection:"column",
		        width:"100%",
		        height:"100vh",
		        overflow:"hidden"
		    }}
		>
		
			<MobileHeader
			    openMenu={
			        () => setShowMenu(true)
			    }
			    openSearch={
			        () => console.log("SEARCH")
			    }
			/>

			<MobileDashboardPhotoNavigator

			    display={showFilters}

			    closeFunction={
			        () => setShowFilters(false)
			    }

			    refFacility={refFacility}

			    facilityId={facilityId}
			    setFacilityId={setFacilityId}

			    floorId={floorId}
			    setFloorId={setFloorId}

			    floorZoneId={floorZoneId}
			    setFloorZoneId={setFloorZoneId}

			    spaceId={spaceId}
			    setSpaceId={setSpaceId}

			    parentSpaceTypeId={parentSpaceTypeId}
			    setParentSpaceTypeId={setParentSpaceTypeId}

			    spaceTypeId={spaceTypeId}
			    setSpaceTypeId={setSpaceTypeId}

			    parentOrganisationId={parentOrganisationId}
			    setParentOrganisationId={setParentOrganisationId}

			    organisationId={organisationId}
			    setOrganisationId={setOrganisationId}

			    showCoreDayOnly={showCoreDayOnly}
			    setShowCoreDayOnly={setShowCoreDayOnly}

			    showDesksMeetings={showDesksMeetings}
			    setShowDesksMeetings={setShowDesksMeetings}

			    resetFunction={resetSearch}

			    setFilterBean={setFilterBean}
			/>

		
		 <div className="mobile-utilisation-all-page">

          


            <div className="mobile-utilisation-all">


                {/*------------------------------------------
                    Heading
                ------------------------------------------*/}

                <div className="mobile-utilisation-all-heading">

                    <div className="mobile-utilisation-all-title">
                        Utilisation Dashboard
                    </div>

                    <div className="mobile-utilisation-all-subtitle">
                        Detailed utilisation analysis,
                        occupancy patterns and workplace
                        performance.
                    </div>

                </div>


                {/*------------------------------------------
                    Navigator Placeholder
                ------------------------------------------*/}

				<button
				    className="mobile-utilisation-all-filter"
				    type="button"
				    onClick={
				        () => setShowFilters(true)
				    }
				>
				    <span>
				        Filters &amp; Location
				    </span>

				    <span>
				        ›
				    </span>
				</button>


                {/*------------------------------------------
                    Utilisation Indicators
                ------------------------------------------*/}

                <div className="mobile-utilisation-all-indicators">

                    <div className="mobile-utilisation-all-ring">

                        <AmChartRingIndicator
                            percentage={utilisationAvg}
                            width={130}
                            height={130}
                            icon="chair"
                            color={COLOR_UTILISATION_OCCUPIED}
                            label="Avg"
                            id="mobileutilisationavg"
                        />

                    </div>


                    <div className="mobile-utilisation-all-ring">

                        <AmChartRingIndicator
                            percentage={utilisationMax}
                            width={130}
                            height={130}
                            icon="chair"
                            color={COLOR_UTILISATION_OCCUPIED}
                            label="Peak"
                            id="mobileutilisationpeak"
                        />

                    </div>

                </div>


                {/*------------------------------------------
                    KPI Grid
                ------------------------------------------*/}

                <div className="mobile-utilisation-all-kpis">

                    <UtilisationKpiBox
                        title="Seats"
                        figure={
                            functions.formatNumber(
                                seats,
                                0
                            )
                        }
                        color={OMNISCAN_CORPORATE_TURQUOIS}
                        width="100%"
                    />


                    <UtilisationKpiBox
                        title="Observations"
                        figure={
                            functions.formatNumber(
                                observations,
                                0
                            )
                        }
                        color={OMNISCAN_CORPORATE_TURQUOIS}
                        width="100%"
                    />


                    <UtilisationKpiBoxDate
                        title="Max On"
                        figure={
                            functions.formatDate(
                                datePeak
                            )
                        }
                        hour={timePeak}
                        width="100%"
                    />


                    <UtilisationKpiBoxDate
                        title="Min On"
                        figure={
                            functions.formatDate(
                                dateMin
                            )
                        }
                        hour={timeMin}
                        width="100%"
                    />

                </div>


                {/*------------------------------------------
                    Breakdown
                ------------------------------------------*/}

                <div className="mobile-utilisation-all-card">

                    <div className="mobile-utilisation-all-card-title">
                        Breakdown
                    </div>

                    <div className="mobile-utilisation-all-card-subtitle">
                        Building / Floor / Workplace
                    </div>

                    <div className="mobile-utilisation-all-chart">

                        <AmChartSimpleBar
                            chartId="mobileutilisationbar"
                            chartData={leftBarChartData}
                            categoryKey="label"
                            valueKey="value"
                            width="100%"
                            height={leftBarChartHeight}
                            onClick={handleBarClick}
                            color={COLOR_UTILISATION_OCCUPIED}
                        />

                    </div>

                </div>


                {/*------------------------------------------
                    Profile
                ------------------------------------------*/}

                <div className="mobile-utilisation-all-card">

                    <UtilisationChartProfileUnused
                        id="mobileutilisationprofileunused"
                        filterBean={filterBean}
                        isMeeting={FALSE}
                    />

                </div>


                {/*------------------------------------------
                    Efficiency
                ------------------------------------------*/}

                <div className="mobile-utilisation-all-card">

                    <UtilisationChartEfficiency
                        id="mobileutilisationefficiency"
                        filterBean={filterBean}
                        isMeeting={FALSE}
                    />

                </div>


                {/*------------------------------------------
                    Timeline
                ------------------------------------------*/}

                <div className="mobile-utilisation-all-card">

                    <div className="mobile-utilisation-all-card-title">
                        Utilisation Profile
                    </div>

                    <div className="mobile-utilisation-all-timeline">

                        <AmChartDateLine
                            chartId="mobileutilisationtimeline"
                            width="100%"
                            height="270px"
                            chartData={dataTimeline}
                            graphs={dataByDateGraphsStacked}
                            dateKey="date"
                            isStacked={true}
                        />

                    </div>

                </div>


            </div>

        </div>
		</div>
    );

}